import React from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  ContentWithVerticalPadding,
} from "components/misc/Layouts.js";
import tw from "twin.macro";
import styled from "styled-components";
import BgTitle from "components/title/BgTitle";
import JccCompany from "components/features/JccCompany";
import ReinforcementInspectionMobileView from "./ReinforcementInspectionMobileView";

import rn_img1 from "../../images/reinforcement/1.png";
import rn_img2 from "../../images/reinforcement/2.png";
import rn_img3 from "../../images/reinforcement/3.png";
import rn_img4 from "../../images/reinforcement/4.png";
import rn_img5 from "../../images/reinforcement/5.png";
import rn_img6 from "../../images/reinforcement/6.png";
import rn_img7 from "../../images/reinforcement/7.png";
import rn_img8 from "../../images/reinforcement/8.png";
import rn_img9 from "../../images/reinforcement/9.png";
import rn_img10 from "../../images/reinforcement/10.png";
import rn_img11 from "../../images/reinforcement/11.png";
import rn_img12 from "../../images/reinforcement/12.png";
import rn_img13 from "../../images/reinforcement/13.png";
import rn_img14 from "../../images/reinforcement/14.png";
import rn_img15 from "../../images/reinforcement/15.png";
import rn_img16 from "../../images/reinforcement/16.png";
import rn_img17 from "../../images/reinforcement/17.png";
import rn_img18 from "../../images/reinforcement/18.png";
import rn_img19 from "../../images/reinforcement/19.png";

// Image Array for Dynamic Rendering
const images = [
  rn_img1,
  rn_img2,
  rn_img3,
  rn_img4,
  rn_img5,
  rn_img6,
  rn_img7,
  rn_img8,
  rn_img9,
  rn_img10,
  rn_img11,
  rn_img12,
  rn_img13,
  rn_img14,
  rn_img15,
  rn_img16,
  rn_img17,
  rn_img18,
  rn_img19,
];

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;

const MainContent = tw.div`w-full lg:w-2/3 mx-auto mb-8`;
const Intro = tw.p`text-sm leading-loose mb-4`;
const List = tw.ul`list-disc list-inside mb-6`;
const ListItem = tw.li`text-sm leading-loose`;
const ProductIntro = tw.div`bg-ncc font-bold text-white p-2 rounded mb-8`;
const ContentGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8`;

const ContentItem = styled.div`
  ${tw`flex flex-col justify-between text-center bg-white p-2 relative`}
  border: 1px dashed #0c4d963d;
  border-radius: 12px;
  max-height: 300px;

  img {
    ${tw`w-full rounded-md`}
    max-height: 200px;
    object-fit: cover;
  }

  .content-name {
    ${tw`text-sm font-bold text-ncc`}
    margin-top: auto; /* Push the text to the bottom */
  }
`;

const ReinforcementInspection = ({ isXs = false }) => {
  const { t } = useTranslation();

  if (isXs) return <ReinforcementInspectionMobileView />;

  const reinforcementDetails = t("reinforcementDetails", {
    returnObjects: true,
  });

  // Track image index for dynamic rendering
  let imageIndex = 0;

  return (
    <BgWrapper>
      <Container>
        <ContentWithVerticalPadding>
          <MainContent>
            <BgTitle text={reinforcementDetails.title} />
            <Intro>{reinforcementDetails.subtitle}</Intro>
            <List>
              {reinforcementDetails.list.map((item, idx) => (
                <ListItem key={idx}>{item}</ListItem>
              ))}
            </List>
          </MainContent>

          {reinforcementDetails.sections.map((section, index) => {
            const sectionImages = images.slice(
              imageIndex,
              imageIndex + section.images
            );
            const sectionFooters = section.footerText; // Get footer text for this section
            imageIndex += section.images;

            return (
              <MainContent key={index}>
                <ProductIntro>
                  <p>{section.header1}</p>
                  <p>{section.header2}</p>
                </ProductIntro>
                <ContentGrid>
                  {sectionImages.map((img, imgIdx) => (
                    <ContentItem key={imgIdx}>
                      <img
                        src={img}
                        alt={`Section ${index + 1} - Image ${imgIdx + 1}`}
                      />
                      <div className="content-name">
                        {sectionFooters[imgIdx]} {/* Display footer text */}
                      </div>
                    </ContentItem>
                  ))}
                </ContentGrid>
              </MainContent>
            );
          })}
        </ContentWithVerticalPadding>
      </Container>
      <div style={{ marginTop: "-100px" }}>
        <JccCompany />
      </div>
    </BgWrapper>
  );
};

export default ReinforcementInspection;
